import { useContext, useState } from 'react';

import BulkCoverPhotoModal from '@atom/components/common/bulkCoverPhotoModal/BulkCoverPhotoModal';
import { Icon, IconButton } from '@atom/mui';
import { AddPhotoAlternateIcon, CloseIcon } from '@atom/mui/icons';
import { hasRolePermissions, ROLE_SETS } from '@atom/utilities/authUtilities';

import InventoryPortalContext from './InventoryPortalContext';

import classes from './inventoryPortal.module.css';

const BulkSelectHeader = () => {
  const { selectedAssets, resetSelectedAssets } = useContext(
    InventoryPortalContext,
  );

  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => {
    setOpen(false);
    resetSelectedAssets();
  };

  const assetCount = selectedAssets.size;

  const showAssignCoverPhoto = hasRolePermissions(ROLE_SETS.ORG_ADMIN);

  return (
    <>
      <div className={classes.bulkHeaderContainer}>
        <div className={classes.bulkLeftContainer}>
          <IconButton onClick={resetSelectedAssets}>
            <Icon icon={CloseIcon} />
          </IconButton>
          <div>{`Selected ${assetCount}`}</div>
        </div>
        {showAssignCoverPhoto && (
          <IconButton
            onClick={() => setOpen(true)}
            tooltip="Assign cover photo"
          >
            <Icon icon={AddPhotoAlternateIcon} />
          </IconButton>
        )}
      </div>
      <BulkCoverPhotoModal
        open={open}
        onClose={handleClose}
        ids={[...selectedAssets]}
      />
    </>
  );
};

export default BulkSelectHeader;
